"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Selectable = _interopRequireDefault(require("../Selectable"));

var _Box = _interopRequireDefault(require("../Box"));

var _index = require("../index");

var __jsx = _react["default"].createElement;
var defaults = {
  $root: function $root(_ref) {
    var focused = _ref.focused;
    return {
      display: "flex",
      flexDirection: "row"
    };
  }
};

function Checkbox() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var description = props.description,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["description"]);
  return __jsx(_Selectable["default"], restProps, function (state) {
    var sx = props.sx;

    if (typeof sx === "function") {
      sx = sx(state);
    }

    var _splitSx = (0, _index.splitSx)(sx),
        _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
        css = _splitSx2[0],
        customSx = _splitSx2[1];

    var labelStyles = customSx.$label || {};

    if (typeof labelStyles === "function") {
      labelStyles = labelStyles(state);
    }

    var labelContainerStyles = customSx.$labelContainer || {};

    if (typeof labelContainerStyles === "function") {
      labelContainerStyles = labelContainerStyles(state);
    }

    var descriptionStyles = customSx.$description || {};

    if (typeof descriptionStyles === "function") {
      descriptionStyles = descriptionStyles(state);
    }

    return __jsx(_Box["default"], {
      sx: [defaults.$root(state), css]
    }, __jsx(_Box["default"], {
      sx: {
        flex: "0 0 auto"
      }
    }, _react["default"].cloneElement((0, _objectSpread2["default"])({}, customSx.$checkmark), restProps)), __jsx(_Box["default"], {
      sx: (0, _objectSpread2["default"])({}, labelContainerStyles)
    }, __jsx(_Box["default"], {
      sx: (0, _objectSpread2["default"])({}, labelStyles)
    }, props.label), props.description && __jsx(_Box["default"], {
      sx: (0, _objectSpread2["default"])({}, descriptionStyles)
    }, props.description)));
  });
}

var _default = Checkbox;
exports["default"] = _default;